/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddMethod/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function AddMethod({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderMethod/Content/AddMethod",
  method,
  locationId,
  person,
  amount,
  onPaymentPageCallback,
  reusableForBluefin
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let paymentAddNewValueData = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'add_new',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: paymentAddNewValueData,
})
let paymentAddNewValueData1 = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'add_new',
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  method,
  locationId,
  person,
  amount,
  onPaymentPageCallback,
  reusableForBluefin
  
})
let paymentMethodValueData = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'method',
})
let constantData = 'ach'
let aggregateData = fromAggregate.equals(paymentMethodValueData, constantData)
let paymentAddNewValueData2 = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'add_new',
})
  return (<React.Fragment
>
<div
  data-testid="AddMethod.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bc-1-29o03w': dtColorsWhite,'--bc-2-29o03w': dtColorsNeutral200,'--pl-3-29o03w': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-4-29o03w': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--c-5-29o03w': paymentAddNewValueData1 ? "default" : "pointer"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="AddMethod.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="AddMethod.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text={aggregateData ? "Add a new bank account" : "Add a new card"}
 data="payment.method"
 data="'ach'"
 aggregate="/Simple/Data/aggregate.js equals"
/>
<Radial
  viewPath={`${viewPath}/Radial`}
 marginRight={-8}
 paddingRight={0}
 data="payment.add_new"
 isSelected={paymentAddNewValueData2}
/>
</div>
</div>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 method={method}
 locationId={locationId}
 person={person}
 amount={amount}
 onPaymentPageCallback={onPaymentPageCallback}
 reusableForBluefin={reusableForBluefin}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}